import { render } from "./inJobWorker.vue?vue&type=template&id=821b24e4"
import script from "./inJobWorker.vue?vue&type=script&lang=js"
export * from "./inJobWorker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__